
export class ClientConfig 
{
    //static ApiBaseUrl = "https://localhost:32769/api/";
   static ApiBaseUrl = "https://mamtemoc.edu.pl/api/";
}

export default ClientConfig;